import { Checkbox } from '@progress/kendo-react-inputs';
import React, { useContext, useEffect, useState } from 'react'
import { callApiWithAuthorization } from '../../API/CallApi';
import { PAYMENT_METHODS_LOADED, PAYMENT_METHOD_SELECTED } from '../../Context/Pricing/Events';
import { PricingContext } from '../../Context/Pricing/PricingContext';
import CardTypeImage from './CardTypeIcon';
import { getPaymentMethodsOfAnOrganization } from '../../API/Payment/Payment';

function CustomerCardList({ organizationId, CardItem, log, onSelect, context = PricingContext }) {

    const { state, dispatch } = useContext(context);

    // const [paymentMethods, setPaymentMethods] = useState([]);

    useEffect(() => {
        getPaymentMethodsOfAnOrganization(organizationId)
            .then(paymentMethods => dispatch({
                type: PAYMENT_METHODS_LOADED,
                payload: paymentMethods
            }))
            .catch(console.error);
    }, []);

    if (
        CardItem &&
        (typeof CardItem === "function" || typeof CardItem === "object")
    ) {
        return state.paymentMethods.map((paymentMethod, index) => (
            <CardItem
                paymentMethod={paymentMethod}
                selected={state.selectedPaymentMethodId === paymentMethod.id}
                onSelect={(e) => dispatch({
                    type: PAYMENT_METHOD_SELECTED,
                    payload: e.value ? paymentMethod.id : ""
                })}
                index={index} />
        ))
    }

    return (
        <div>
            { state.paymentMethods.map(paymentMethod => (
                <div className='p-2 border rounded mt-2' key={paymentMethod.id}>
                    <Checkbox
                        label={`****${paymentMethod.card.last4}`}
                        checked={state.selectedPaymentMethodId === paymentMethod.id}
                        value={state.selectedPaymentMethodId === paymentMethod.id}
                        onChange={(e) => dispatch({
                            type: PAYMENT_METHOD_SELECTED,
                            payload: e.value ? paymentMethod.id : ""
                        })}
                    />
                </div>
            ))}
        </div>
    )
}

export default CustomerCardList